module.exports = __webpack_public_path__ + "img/mahoutcamp_tech_Normal_ua.627757d9.webp";